/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Create the store
 *
 * @file index.js
 * @author JP
 * @since 1.0.0
 */

// mobx store models
import Resource from './Resource';
import StoreRegistry from '../common/StoreRegistry';
import {
  BOOK_LEVEL_RESOURCE,
  BULK_DOWNLOAD_STATUS_NOT_STARTED
} from '../common/constants';

const createStore = (userRole, currentPageId, userSelectedDetails) => {
  StoreRegistry.register('resources', Resource.create({
    bulkDownloadStatus: BULK_DOWNLOAD_STATUS_NOT_STARTED,
    currentPageId,
    filteredContentType: userSelectedDetails.filteredContentType || [],
    filteredResourceData: [],
    filterOn: userSelectedDetails.filterOn || false,
    hasDownloadResource: false,
    isBookResource: false,
    isCurrentTabEmpty: false,
    isFetched: false,
    isNetworkError: false,
    isPageResource: false,
    isSearchOn: userSelectedDetails.isSearchOn || false,
    resourceFlatData: [],
    resourceLevelTab: userSelectedDetails.resourceLevelTab || BOOK_LEVEL_RESOURCE,
    retryCount: 0,
    searchedKeyword: userSelectedDetails.searchedKeyword || '',
    selectAll: false,
    selectedResources: [],
    structuredResourceData: [],
    userRoleTab: userSelectedDetails.userRoleTab || userRole,
    showStudentTab: false,
    showTeacherTab: false
  }));
};

export default createStore;
